const Loaders = () => {
    return (
        <p>Loading please wait...</p>
    )
}

export default Loaders